import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { Router } from "@angular/router";
import { AuthService } from "./auth.service";

@Injectable({
  providedIn: "root",
})
export class ApiService {
  private baseUrl: string = "https://esecure.echobitsone.com/api";

  // private baseUrl: string = 'http://localhost:3001/api/v1';
  // private baseUrl: string = 'http://localhost:4000/api/v1';

  //test admin credentials: email = superadmin@super.com  || password = securePassword123

  constructor(
    private http: HttpClient,
    private router: Router,
    private authService: AuthService
  ) {}

  login(email: string, password: string): Observable<any> {
    const url = `${this.baseUrl}/admin/login`;
    const headers = new HttpHeaders({ "Content-Type": "application/json" });
    const body = { email, password };

    return this.http
      .post<any>(url, body, { headers })
      .pipe(catchError(this.handleError<any>("login")));
  }

  refreshToken(): Observable<any> {
    const url = `${this.baseUrl}/admin/refresh-token`;
    const headers = new HttpHeaders({ "Content-Type": "application/json" });
    const body = { token: this.authService.getRefreshToken() };

    return this.http
      .post<any>(url, body, { headers })
      .pipe(catchError(this.handleError<any>("refreshToken")));
  }

  getAdmins(): Observable<any> {
    const url = `${this.baseUrl}/admin/admins`;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.authService.getJwtToken()}`,
    });

    return this.http
      .get<any>(url, { headers })
      .pipe(catchError(this.handleError("getAdmins")));
  }

  getDashboardData(): Observable<any> {
    const url = `${this.baseUrl}/admin/dashboard`;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.authService.getJwtToken()}`,
    });
    return this.http
      .get<any>(url, { headers })
      .pipe(catchError(this.handleError("getDashboardData")));
  }

  addEstateToWaitList(data: any): Observable<any> {
    const url = `${this.baseUrl}/public/waitlist`;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });
    return this.http.post(url, data, { headers });
  }

  resetUserPassword(userId: string): Observable<any> {
    const url = `${this.baseUrl}/admin/users/reset-password/${userId}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.authService.getJwtToken()}`,
    });

    return this.http
      .put<any>(url, {}, { headers })
      .pipe(catchError(this.handleError("resetUserPassword")));
  }

  private handleError<T>(operation = "operation", result?: T) {
    return (error: HttpErrorResponse): Observable<T> => {
      console.error(`${operation} failed: ${error.message}`);
      return throwError(() => error);
    };
  }
}
